import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSortable } from "@dnd-kit/sortable";
import { useFormikContext } from "formik";
import React, { useState } from "react";
export default function DocTableRow(_param) {
    var item = _param.item, index = _param.index, setProductRow = _param.setProductRow, columdisplay = _param.columdisplay, customSort = _param.customSort, rowCount = _param.rowCount, dataID = _param.dataID, columnPresets = _param.columnPresets, filterDisplay = _param.filterDisplay, props = _object_without_properties(_param, [
        "item",
        "index",
        "setProductRow",
        "columdisplay",
        "customSort",
        "rowCount",
        "dataID",
        "columnPresets",
        "filterDisplay"
    ]);
    var _useSortable = useSortable({
        id: item.rowID
    }), attributes = _useSortable.attributes, listeners = _useSortable.listeners, setNodeRef = _useSortable.setNodeRef, transform = _useSortable.transform, transition = _useSortable.transition;
    var _useState = _sliced_to_array(useState(null), 2), anchorEl = _useState[0], setAnchorEl = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), popid = _useState1[0], setPopid = _useState1[1];
    var values = useFormikContext().values;
    var productStandardShareProp = {
        item: item,
        index: index,
        setProductRow: setProductRow,
        columdisplay: columdisplay,
        customSort: customSort,
        rowCount: rowCount,
        values: values,
        dataID: dataID,
        attributes: attributes,
        listeners: listeners,
        setNodeRef: setNodeRef,
        transform: transform,
        transition: transition,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        popid: popid,
        setPopid: setPopid,
        filterDisplay: filterDisplay
    };
    return /*#__PURE__*/ _jsx("tr", {
        className: "",
        children: columnPresets.map(function(col, idx) {
            return /*#__PURE__*/ _jsx(React.Fragment, {
                children: col.render(productStandardShareProp)
            }, col.key || idx);
        })
    });
}
